export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
export const SECOND_API_URL =
  process.env.REACT_APP_SECOND_API_URL || "http://localhost:3001";
export const BASE_FOLDER = process.env.REACT_APP_BASE_FOLDER || "";
export const APP_URL = process.env.REACT_APP_APP_URL || "http://localhost:3000";
